<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import SpeechBubbleTail from '@/components/svg/SpeechBubbleTail.vue';

  const props = defineProps({
    isMobile:{
      type: Boolean,
      default: false,
    }
  })
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="personality-wrapper">
          <section class="guide-box">
            <div class="guide-intro bg-highlight">
              <div class="guide-intro__header">
                <div class="highlight">분석의 기반</div>
                <div class="title">나를 이해하기 위한 출발점!</div>
              </div>
              <div class="speech-bubble__container">
                <div class="speech-bubble__row orange">
                  <div class="speech-bubble">
                    나는 왜 이런 성향을 가졌을까?
                    <!-- <div class="speech-bubble__tail"></div> -->
                     <SpeechBubbleTail :color="'#db9823'" class="speech-bubble__tail" />
                  </div>
                </div>
                <div class="speech-bubble__row white">
                  <div class="speech-bubble">
                    타고난 기질?
                    <div class="speech-bubble__tail"></div>
                  </div>
                </div>
                <div class="speech-bubble__row white">
                  <div class="speech-bubble">
                    아니면 살아오면서 형성된 모습?
                    <div class="speech-bubble__tail"></div>
                  </div>
                </div>
              </div>
              <div>
                우리는 가끔 스스로에게 질문하게 됩니다.<br />
                명확히 구분할 수는 않지만 <span class="highlight">‘나를 더 잘 알고 싶다’</span>는
                마음만큼은 분명합니다.<br />
                낭만성향분석은 그런 마음에서 출발했습니다.
              </div>
            </div>
          </section>
          <section class="guide-box">
            <div class="guide-box__title"
            :class="{mobile: isMobile}">
              <div class="box-title__keyword">분석의 특징</div>
              <span class="box-title__txt"> 응답이 아닌 구조로 성향을 해석합니다!</span>
            </div>
            <div class="box-content gray">
              <div class="cont-top_txt">
                낭만성향분석은 사람마다 다른 감정 상태나 환경의 영향을 최소화하기 위해,<br />
                생년월일을 기반으로 구성된
                <span class="highlight">사주원국의 오행 구조를 분석</span>합니다.
              </div>
              <div class="cont-bottom">
                <div class="guide-eight-img" />
              </div>
            </div>
            <div class="box-body">
              <span class="box-body__txt">
                문항이 아닌 <span class="highlight">구조</span>, 응답이 아닌
                <span class="highlight">원리</span>에 <span class="highlight">기반한 해석</span>을
                통해 더 균형 있고 깊이 있는 성향 분석을 제공해드리고자 합니다.
              </span>
            </div>
          </section>
          <!-- <section class="guide-box">
            <div class="guide-intro bg-highlight">
              <div class="guide-intro__header">
                <div class="highlight">분석의 기반</div>
                <div class="title">나를 이해하기 위한 출발점!</div>
              </div>
              <div class="speech-bubble__container">
                <div class="speech-bubble__row orange">
                  <div class="speech-bubble">
                    나는 왜 이런 성향을 가졌을까?
                    <div class="speech-bubble__tail"></div>
                  </div>
                </div>
                <div class="speech-bubble__row white">
                  <div class="speech-bubble">
                    타고난 기질?
                    <div class="speech-bubble__tail"></div>
                  </div>
                </div>
                <div class="speech-bubble__row white">
                  <div class="speech-bubble">
                    아니면 살아오면서 형성된 모습?
                    <div class="speech-bubble__tail"></div>
                  </div>
                </div>
              </div>
              <div>
                우리는 가끔 스스로에게 질문하게 됩니다.<br />
                명확히 구분할 수는 않지만 <span class="highlight">‘나를 더 잘 알고 싶다’</span>는
                마음만큼은 분명합니다.<br />
                낭만성향분석은 그런 마음에서 출발했습니다.
              </div>
            </div>

            <div class="guide-box__title">
              <div class="box-title__keyword">분석의 기반</div>
              <span class="box-title__txt"> 나를 이해하기 위한 출발점! </span>
            </div>
            <div class="box-body">
              <span class="box-body__txt"> 우리는 때때로 스스로에게 질문하게 됩니다. </span>
              <sapn class="box-body__txt highlight"> "나는 왜 이런 성향을 가졌을까?" </sapn>
              <span class="box-body__txt">
                타고난 기질인지, 자라오며 형성된 모습인지,<br />
                명확히 구분되지는 않지만 나를 더 잘 이해하고 싶은 마음만은 분명합니다.
              </span>
            </div>
            <div class="box-content">
              <div class="cont-top_txt">
                ‘낭만성향분석’은 사주명리학의 원리와 오행 구조를 기반으로 구성된<br />
                성향 분석 서비스입니다.
              </div>
              <div class="cont-bottom">
                <div class="guide__circle-box">
                  <div class="circle-box__overlap-group">
                    <div class="personality-circle clear">
                      <span class="circle__main-txt">
                        타고난 기질의<br />
                        중심 성향
                      </span>
                      <span class="circle__sub-txt"> 기본성향코드 </span>
                    </div>
                    <div class="personality-circle light overlap-circle">
                      <span class="circle__main-txt">
                        삶의 균형을 돕는<br />
                        보완 에너지
                      </span>
                      <span class="circle__sub-txt"> 용신코드 </span>
                    </div>
                  </div>
                  <div class="">
                    <div class="arrow-icon" />
                  </div>
                  <div class="personality-circle primary">
                    <span class="circle__main-txt white">
                      입체적이고 현실적<br />
                      자기 이해
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-body">
              <span class="box-body__txt">
                타고난 에너지와 삶의 경험이 겹쳐져 이루어진 '나'라는 존재를 이 분석을 통해 조금 더
                입체적으로 바라볼 수 있기를 바랍니다.
              </span>
            </div>
          </section> -->
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper">
          <section class="guide-box">
            <div
              class="guide-box__title"
              :class="{mobile: isMobile}"
            >
              <div class="box-title__keyword">분석 형식</div>
              <span class="box-title__txt">
                익숙한 형식 안에 명리학적 해석 기준을 담았습니다.
              </span>
            </div>
            <div class="box-body">
              <span class="box-body__txt">
                요즘은 다양한 온라인 심리 검사나 콘텐츠를 통해 자신의 성향을 유형화해보는 것이
                자연스러운 경험이 되었습니다.
              </span>
              <span class="box-body__txt">
                <span class="highlight">4자리 코드 형식(ex ESFJ 등)</span>은 <br />기질을 간편하고
                직관적으로 이해할 수 있는 방식으로 널리 활용되고 있습니다.
              </span>
            </div>
            <div class="box-content gray">
              <span class="cont-top_txt">
                낭만성향분석은 이러한 익숙한 형식을 참고하여<br />사용자가 보다 편하게 자신의 성향을
                이해할 수 있도록 <br /><span class="highlight">결과를 4자리 코드 형식</span>을
                참고하여 분석 결과를 전달해 드리고 있습니다.
              </span>
              <div class="guide-star-grape-box">
                <div class="guide-star-grape-img-box"></div>
              </div>
              <div class="guide-balance-code-box"
                :class="{mobile: isMobile}">
                <div class="txt-box">성향조화를 돕는 밸런스 코드</div>
                <div class="code-box">
                  <span class="exp-txt">예시</span>
                  <span class="code-txt-box">
                    <span class="code-txt color1">E</span>
                    <span class="code-txt color2">S</span>
                    <span class="code-txt color3">F</span>
                    <span class="code-txt color4">J</span>
                  </span>
                  <span class="icon-plus"></span>
                  <span class="code-txt-black">B</span>
                </div>
              </div>
              <span class="cont-top_txt">
                4가지 성향코드와 함께 제안드리는 <span class="highlight">+ 컬러코드 (용신)</span>는<br/>
                사주 전체에 조화를 이루는 안정적이고 긍정적인 핵심요소를 의미합니다.
              </span>
            </div>
          </section>
          <section class="guide-box">
            <div class="box-body">
              <span class="box-body__txt">
                그러나 익숙한 표현방식으로 제공해드리지만 그 안에 담긴
                <span class="highlight">분석의 기준과 해석의 방식</span>은 본질적으로 다릅니다.
              </span>
              <span class="box-body__txt">
                <span class="highlight">사주명리학의 해석 원리</span>를 기반으로<br />
                타고난 오행의 배치와 조후(調候), 그리고 오행 간의 균형과 흐름까지 종합적으로
                읽어내어
                <span class="highlight">핵심 기질과 경향적 성향 패턴을 도출</span>하고 있습니다.
              </span>
            </div>
            <!-- <div class="box-img">
              <div class="guide-star-img" />
            </div> -->
          </section>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
<style scoped lang="scss">
@import '@/assets/nangman_style/_analysis_main_color.scss';
.arrow-icon {
  width: 24px;
  height: 24px;
  background: url('@manseImages/icon-double-arrow.svg') center center no-repeat;
  background-size: contain;
}
.guide-star-img {
  height: 160px;
  aspect-ratio: 9/8;
  background: url('@manseImages/personality/prsonaity-guidle-star.png') center center no-repeat;
  background-size: contain;
}
.guide-eight-img {
  width: 270px;
  aspect-ratio: 270/116;
  background: url('@manseImages/personality/personality-guide-eight.png') center center no-repeat;
  background-size: contain;
}
.guide-star-grape-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.guide-star-grape-img-box {
  width: 332px;
  aspect-ratio: 332/200;
  background: url('@manseImages/personality/guide-star-grape.png') center center no-repeat;
  background-size: contain;
}
.guide-balance-code-box {
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 12px;
  border: 1px solid var(--Gray-300, #ebebeb);
  background: var(--gray-100-white, #fff);
  &.mobile{
    flex-direction: column;
    padding: 8px 20px;
    gap: 8px;
  }
  .txt-box {
    color: var(--Gray-800, #333);
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 160% */
  }
  .code-box {
    display: flex;
    align-items: center;
    gap: 8px;
    .exp-txt {
      display: flex;
      height: 22px;
      padding: 2px 6px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 30px;
      background: var(--Gray-300, #ebebeb);
      color: var(--Gray-500, #949494);
      font-family: Pretendard;
      font-size: 11px;
      font-style: normal;
      font-weight: 700;
      line-height: 16px; /* 145.455% */
    }
    .code-txt-box {
      display: flex;
      align-items: center;
      gap: 4px;
      opacity: 0.2;
      .code-txt {
        color: #ff6867;
        text-align: center;
        font-family: Pretendard;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px; /* 114.286% */
        &.color1 {
          color: #ff6867;
        }
        &.color2 {
          color: #7d67fd;
        }
        &.color3 {
          color: #e53c9c;
        }
        &.color4 {
          color: #4881ce;
        }
      }
    }
    .icon-plus {
      width: 20px;
      height: 20px;
      background: url('@manseImages/personality/icon_plus2.png') center center no-repeat;
      background-size: contain;
    }
    .code-txt-black {
      color: var(--gray-100-white, #fff);
      text-align: center;
      font-family: Pretendard;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px; /* 177.778% */
      display: flex;
      width: 32px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 40px;
      background: var(--black-100, #404040);
    }
  }
}
.guide-intro {
  width: 100%;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  color: var(--Gray-800, #333);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  .guide-intro__header {
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    .title {
      font-size: 20px;
      line-height: 32px;
    }
  }
}
.speech-bubble__container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  .speech-bubble__row {
    width: 100%;
    display: flex;
    .speech-bubble {
      position: relative;
      width: fit-content;
      padding: 8px 12px;
      border-radius: 12px;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
    }
    .speech-bubble__tail {
      position: absolute;
      top: 50%;
      width: 28px;
      height: 28px;
    }
    &.orange {
      justify-content: flex-start;
      .speech-bubble {
        background: $analysis-personality;
        text-align: left;
        color: var(--gray-100-white, #fff);
      }
      .speech-bubble__tail {
        left: 0;
        transform: translate(-50%, -50%);
        background: url('/src/assets/images_manse/personality/speech-bubble__tail-yellow.svg')
          center center no-repeat;
      }
    }
    &.white {
      justify-content: flex-end;
      .speech-bubble {
        background: var(--gray-100-white, #fff);
        text-align: right;
        color: var(--Gray-700, #575757);
      }
      .speech-bubble__tail {
        right: 0;
        transform: translate(50%, -50%);
        background: url('/src/assets/images_manse/personality/speech-bubble__tail-white.svg') center
          center no-repeat;
      }
    }
  }
}
</style>
